/* AWP slide in cart. Built from the mockup approved 2026-10-13 ("06 Projects/Slide In Cart").
   Runs in both arms of the cart test: in the "new" arm it switches UpCart off for this visitor and
   opens this drawer instead; in the "upcart" arm it only tags the cart. If this file fails to load
   or throws before it is ready, UpCart stays on (the snippet resets UpCart's switch on every page),
   and if the drawer breaks later, the tab goes back to UpCart from the next page on.
   Prices always come from /cart.js. The ladder labels come from the AWP Discounts promotions mirror,
   so the cart never promises a price or a free kit that checkout will not honour. */
(function () {
  "use strict";
  if (window.__awpCart) return;
  window.__awpCart = true;

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById("awp-cart-config").textContent); } catch (e) { return; }
  if (!CFG.enabled) return;

  var COOKIE = "awp_cart_arm";
  var UPCART_KEY = "upcart-traffic-allocation-override";
  var OFF_KEY = "awp-cart-off"; // set when the drawer broke in this tab: UpCart from the next page on

  /* ---------- the coin flip ---------- */

  function readCookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function writeCookie(name, value, days) {
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + exp + "; path=/; SameSite=Lax";
  }
  var isArm = function (a) { return a === "new" || a === "upcart"; };
  function pickArm() {
    var forced = null;
    try { forced = new URLSearchParams(location.search).get("awp_cart"); } catch (e) {}
    // Staff and QA: one day only, and the cart is marked so the test read can leave it out.
    if (isArm(forced)) {
      writeCookie(COOKIE, forced, 1);
      writeCookie(COOKIE + "_qa", "1", 1);
      return { arm: forced, inTest: true, qa: true };
    }
    var qa = readCookie(COOKIE + "_qa") === "1";
    var have = readCookie(COOKIE);
    // Safari keeps script cookies 7 days at most, so a returning shopper's cart remembers the arm too.
    if (!isArm(have) && isArm(CFG.cartArm) && !qa) { have = CFG.cartArm; writeCookie(COOKIE, have, 60); }
    if (isArm(have)) return { arm: have, inTest: true, qa: qa };
    // Before the test starts nobody is assigned, so Wednesday's flip starts clean.
    var start = Date.parse(CFG.testStart || "");
    if (!(Date.now() >= start)) return { arm: "upcart", inTest: false, qa: false };
    var arm = Math.random() * 100 < (CFG.splitPercent || 0) ? "new" : "upcart";
    writeCookie(COOKIE, arm, 60);
    return { arm: arm, inTest: true, qa: false };
  }

  var PICK = pickArm();

  function setUpcart(on) {
    // UpCart reads this at start: "inactive" turns it off for this tab. Removed, UpCart uses its own setting.
    try { if (on) sessionStorage.removeItem(UPCART_KEY); else sessionStorage.setItem(UPCART_KEY, "inactive"); } catch (e) {}
  }

  /* ---------- money and words ---------- */

  // Outside USD the "$" gets its country letters (CA$, A$, NZ$), the same as the breaker page (Oct 25 2026).
  var DSYM = !CFG.currency || CFG.currency === "USD" ? "$" : ({ CAD: "CA$", AUD: "A$", NZD: "NZ$" })[CFG.currency] || CFG.currency.slice(0, 2) + "$";
  var curSym = function (s) { return DSYM === "$" ? s : String(s).replace("$", DSYM); };
  function money(cents) {
    var fmt = CFG.moneyFormat || "${{amount}}";
    var fix = function (n, d, t, dec) {
      var p = (n / 100).toFixed(d).split(".");
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t || ",") + (p[1] ? (dec || ".") + p[1] : "");
    };
    return curSym(fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === "amount_no_decimals") return fix(cents, 0);
      if (k === "amount_with_comma_separator") return fix(cents, 2, ".", ",");
      if (k === "amount_no_decimals_with_comma_separator") return fix(cents, 0, ".");
      if (k === "amount_with_apostrophe_separator") return fix(cents, 2, "'");
      return fix(cents, 2);
    }));
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function kitWords(n) {
    return n === 1 ? FREE + " Training Kit" : n + " " + FREE + " Training Kits";
  }
  // Jared, Oct 23: FREE in bold capitals everywhere, the same as checkout.
  var FREE = '<strong class="fr">FREE</strong>';

  /* ---------- promotions mirror (AWP Discounts) ---------- */

  var numId = function (gid) { return String(gid == null ? "" : gid).split("/").pop(); };
  var tierMin = function (t) { return t.minCents != null ? t.minCents : t.minQty; };

  function readMirror() {
    var el = document.querySelector(".awp-promotions-mirror");
    if (!el) return [];
    try {
      var m = JSON.parse(el.textContent);
      var now = Date.now();
      return (m.promotions || []).filter(function (p) {
        if (!p.rule || p.rule.enabled === false || p.status === "EXPIRED") return false;
        if (p.startsAt && now < Date.parse(p.startsAt)) return false;
        if (p.endsAt && now >= Date.parse(p.endsAt)) return false;
        return true;
      });
    } catch (e) { return []; }
  }

  function inScope(rule, productId) {
    var ids = (rule.scope && rule.scope.productIds) || [];
    return ids.map(numId).indexOf(String(productId)) !== -1;
  }

  // Code promotions count only when their code is on the cart or the app puts it there itself.
  function usable(p, cart) {
    var isCode = (p.codes && p.codes.length) || /DiscountCodeNode/.test(String(p.id));
    if (!isCode) return true;
    if (p.rule.autoApplyCode && p.codes && p.codes.length) return true;
    var have = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
    return (p.codes || []).some(function (c) { return have.indexOf(String(c).toUpperCase()) !== -1; });
  }

  // Fixed amounts in a rule are written in US dollars. In a CAD or AUD cart, Shopify may or may not convert
  // them (on Oct 23 it did not: $3 off came off as CA$3), so the caller passes the scale checkout really uses.
  function tierSaving(unit, tier, rate) {
    var t = (tier.discounts && tier.discounts[0]) || tier;
    rate = rate || 1;
    if (t.fixedPriceCents != null) return Math.max(0, unit - Math.round(t.fixedPriceCents * rate));
    if (t.amountOffCents != null) return Math.min(unit, Math.round(t.amountOffCents * rate));
    return Math.floor((unit * (t.percent || 0)) / 100);
  }

  // Outside the shop's currency, tell from the cart itself whether checkout converts the rule's dollar
  // amounts: whichever of "as written" or "converted" matches what Shopify charges now. With no tier
  // reached yet there is nothing to compare, and the cart goes with as written, which is what Shopify did on Oct 23.
  function fxScale(cart, unit, tiers) {
    if (!CFG.currency || CFG.currency === CFG.shopCurrency) return 1;
    var rate = Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
    var br = (cart.items || []).filter(isBreaker);
    var q = br.reduce(function (n, i) { return n + i.quantity; }, 0);
    var on = tiers.filter(function (t) { return q >= tierMin(t); });
    if (!q || !on.length || rate === 1) return 1;
    var real = br.reduce(function (n, i) { return n + i.final_line_price; }, 0) / q;
    var at = function (r) { return Math.min.apply(null, on.map(function (t) { return unit - tierSaving(unit, t, r); })); };
    return Math.abs(at(rate) - real) < Math.abs(at(1) - real) ? rate : 1;
  }

  function giftsEarned(rule, q) {
    if (rule.repeatEvery) return Math.floor(q / rule.repeatEvery) * (rule.giftsPerRepeat || 1);
    var reached = (rule.tiers || []).filter(function (t) { return q >= tierMin(t); });
    if (!reached.length) return 0;
    if (rule.accumulate) return reached.reduce(function (s, t) { return s + (t.gifts || 0); }, 0);
    return reached.sort(function (a, b) { return tierMin(b) - tierMin(a); })[0].gifts || 0;
  }

  // Gift tiers spaced evenly (10 gets 1, 20 gets 2, 30 gets 3) are the same as "every 10", even when the app
  // writes them out one by one. Returns { repeatEvery, giftsPerRepeat } for those, otherwise null.
  function evenGifts(rule) {
    var t = (rule.tiers || []).slice().sort(function (a, b) { return tierMin(a) - tierMin(b); });
    if (t.length < 2 || rule.accumulate) return null;
    var m = tierMin(t[0]), g = t[0].gifts || 0;
    if (!m || !g) return null;
    for (var i = 0; i < t.length; i++) if (tierMin(t[i]) !== m * (i + 1) || (t[i].gifts || 0) !== g * (i + 1)) return null;
    return { repeatEvery: m, giftsPerRepeat: g };
  }

  // The steps the breaker box shows: price tiers plus free kit steps, each with its price each
  // and the kits it earns. Built from the live rules, at the cart's own unit price. Returns null when
  // no live price tier is found, and the box then shows no ladder at all rather than a wrong one.
  // Free kits the breakers in this cart have earned, and the gift rule that gives them.
  function giftsDue(cart) {
    var bq = (cart.items || []).filter(isBreaker).reduce(function (s, i) { return s + i.quantity; }, 0);
    var best = { n: 0, id: null };
    readMirror().forEach(function (p) {
      if (!usable(p, cart) || !inScope(p.rule, CFG.breakerProductId) || p.rule.type !== "gift" || p.rule.basis === "amount") return;
      var n = giftsEarned(p.rule, bq);
      if (n > best.n) best = { n: n, id: p.rule.id };
    });
    var have = (cart.items || []).filter(isGift).reduce(function (s, i) { return s + i.quantity; }, 0);
    return { due: best.n, have: have, id: best.id };
  }

  // The AWP Discounts embed adds free kits a moment after a change. Checkout waits for them, 2.5 s at most.
  // GIFT_FALLBACK: after the wait, add any still missing ourselves, with the rule's _awp_gift mark.
  // On since Oct 24: checkout prices these $0 and the embed adds no second kit on top (tested at 10 and 20).
  var GIFT_FALLBACK = true;
  function giftsReady() {
    var t0 = Date.now();
    var look = function () {
      return getCart().then(function (c) {
        var g = giftsDue(c);
        if (g.have >= g.due) return true;
        if (Date.now() - t0 < 2500) return new Promise(function (r) { setTimeout(r, 300); }).then(look);
        if (!GIFT_FALLBACK || !g.id || !CFG.kitVariantId) return false;
        return post("/cart/add.js", { items: [{ id: CFG.kitVariantId, quantity: g.due - g.have, properties: { _awp_gift: g.id } }] })
          .then(function () { return true; }, function () { return false; });
      });
    };
    return look().catch(function () { return false; });
  }

  function goCheckout(btn) {
    var due = S.cart ? giftsDue(S.cart) : { due: 0, have: 0 };
    if (due.have >= due.due) { location.href = "/checkout"; return; }
    btn.disabled = true;
    btn.textContent = "Getting your FREE kit...";
    try { window.clarity && window.clarity("event", "awp_cart_gift_wait"); } catch (x) {}
    giftsReady().then(function (ok) {
      if (!ok) { try { window.clarity && window.clarity("event", "awp_cart_gift_missing"); } catch (x) {} }
      location.href = "/checkout";
    });
  }

  // Copied from AWP Checkout's abroad-pack-price function (most breakers first, US price each in cents).
  var ABROAD = ["CAD", "AUD", "NZD"];
  var ABROAD_TIERS = [[10, 1695], [5, 1795], [3, 1895]];
  // Closest price ending in .95; a tie goes to the lower price.
  function nearest95(cents) {
    var low = Math.floor(cents / 100) * 100 - 5;
    return cents - low <= low + 100 - cents ? low : low + 100;
  }

  function ladder(cart, unit) {
    var promos = readMirror().filter(function (p) { return usable(p, cart) && inScope(p.rule, CFG.breakerProductId); });
    var tiered = promos.filter(function (p) { return p.rule.type === "tiered" && p.rule.basis !== "amount" && (p.rule.tiers || []).length; });
    if (!tiered.length) return null;
    var gifts = promos.filter(function (p) { return p.rule.type === "gift" && p.rule.basis !== "amount"; });
    var tiers = [];
    tiered.forEach(function (p) { tiers = tiers.concat(p.rule.tiers); });
    var rate = fxScale(cart, unit, tiers);
    // The best of any live rule at each count, the way checkout gives the shopper the best price.
    var priceAt = function (q) {
      var best = unit;
      tiers.forEach(function (t) { if (q >= tierMin(t)) best = Math.min(best, unit - tierSaving(unit, t, rate)); });
      return best;
    };
    // Abroad, checkout prices breaker packs with "BreakerDeal Abroad" (AWP Checkout, abroad-pack-price):
    // the US pack price at Shopify's rate, moved to the closest .95. Same tiers and rounding as that function.
    if (ABROAD.indexOf(CFG.currency) !== -1) {
      var fx = Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 0);
      if (fx > 0) priceAt = function (q) {
        var t = ABROAD_TIERS.filter(function (x) { return q >= x[0]; })[0];
        return t ? Math.min(unit, nearest95(Math.round(t[1] * fx))) : unit;
      };
    }
    var kitsAt = function (q) {
      return gifts.reduce(function (m, p) { return Math.max(m, giftsEarned(p.rule, q)); }, 0);
    };
    var repeat = null;
    var mins = [1];
    tiers.forEach(function (t) { mins.push(tierMin(t)); });
    gifts.forEach(function (p) {
      var ev = p.rule.repeatEvery ? p.rule : evenGifts(p.rule);
      if (ev) {
        // "1 kit at 10, 2 at 20, 3 at 30..." reads as one step: a free kit for every 10.
        repeat = ev;
        for (var k = ev.repeatEvery; k <= Math.max(10, ev.repeatEvery); k += ev.repeatEvery) mins.push(k);
      } else (p.rule.tiers || []).forEach(function (t) { mins.push(tierMin(t)); });
    });
    mins = mins.filter(function (v, i, a) { return v >= 1 && a.indexOf(v) === i; }).sort(function (a, b) { return a - b; });
    // A step that changes neither the price nor the kits is not a step.
    mins = mins.filter(function (m, i) {
      return i === 0 || priceAt(m) < priceAt(mins[i - 1]) || kitsAt(m) > kitsAt(mins[i - 1]);
    });
    var steps = mins.map(function (min, i) {
      var nextMin = mins[i + 1];
      var label = !nextMin ? min + " or more" : nextMin - 1 === min ? String(min) : min + " - " + (nextMin - 1);
      return { min: min, label: label, each: priceAt(min), kits: kitsAt(min) };
    });
    return { steps: steps, priceAt: priceAt, kitsAt: kitsAt, repeat: repeat };
  }

  /* ---------- the cart ---------- */

  var S = { cart: null, compare: {}, busy: 0, open: false, error: "", seq: 0, shown: 0, ppWant: null };

  var post = function (url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
      credentials: "same-origin"
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j && (j.description || j.message) || "Cart error");
        return j;
      });
    });
  };
  var getCart = function () {
    return fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin", cache: "no-store" })
      .then(function (r) { if (!r.ok) throw new Error("cart.js " + r.status); return r.json(); }).then(function (c) { /* Cart in another currency (country changed in another tab): reload once so every price and label matches the cart (Oct 25 2026). */ if (c && c.currency && CFG.currency && c.currency !== CFG.currency) { var k = "awp-cart-cur-reload", t = 0; try { t = Number(sessionStorage.getItem(k)) || 0; sessionStorage.setItem(k, String(Date.now())); } catch (e) {} if (Date.now() - t > 15000) { location.reload(); return new Promise(function () {}); } } return c; });
  };

  var isBreaker = function (i) { return String(i.product_id) === String(CFG.breakerProductId) && !isGift(i); };
  var isGift = function (i) { return Boolean(i.properties && i.properties._awp_gift); };
  // Package protection belongs to snippets/awp-protection.liquid (contract v1, 2026-10-23): the drawer
  // shows its checkbox and calls its API, and never adds the line itself.
  var PROT = function () { return window.AWPProtection || null; };
  var isProtection = function (i) {
    var P = PROT();
    if (P && P.isProtectionLine) { try { return Boolean(P.isProtectionLine(i)); } catch (e) {} }
    return /^AWP-PROTECT-/.test(String(i.sku || "")) || i.handle === "package-protection";
  };

  // /cart.js has no compare-at price, so read it from each product once a session.
  function loadCompare(cart) {
    var handles = [];
    cart.items.forEach(function (i) {
      if (isGift(i) || isProtection(i) || S.compare[i.variant_id] !== undefined) return;
      if (handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map(function (h) {
      var key = "awp-cart-cmp:" + (CFG.currency || "") + ":" + h;
      var hit = null;
      try { hit = JSON.parse(sessionStorage.getItem(key) || "null"); } catch (e) {}
      var use = function (map) { Object.keys(map).forEach(function (id) { S.compare[id] = map[id]; }); };
      if (hit && Date.now() - hit.at < 6e5) { use(hit.map); return null; }
      return fetch("/products/" + encodeURIComponent(h) + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var map = {};
          p.variants.forEach(function (v) { map[v.id] = v.compare_at_price || 0; });
          use(map);
          try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), map: map })); } catch (e) {}
        })
        .catch(function () {});
    }));
  }

  var regUnit = function (i) {
    var c = S.compare[i.variant_id] || 0;
    var base = i.original_price || (isGift(i) ? CFG.kitPriceCents || 0 : 0);
    return c > base ? c : base;
  };

  /* ---------- the drawer ---------- */

  var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>';
  var root, panel, body, live;

  function build() {
    root = document.createElement("div");
    root.id = "awp-cart";
    root.setAttribute("hidden", "");
    root.innerHTML =
      '<div class="awpc-shade" data-awpc-close></div>' +
      '<div class="awpc-panel" role="dialog" aria-modal="true" aria-label="Your cart" tabindex="-1">' +
      '<div class="awpc-body"></div><div class="awpc-live" aria-live="polite"></div></div>';
    document.body.appendChild(root);
    panel = root.querySelector(".awpc-panel");
    body = root.querySelector(".awpc-body");
    live = root.querySelector(".awpc-live");
    root.addEventListener("click", onClick);
    root.addEventListener("change", onChange);
    document.addEventListener("keydown", onKey);
  }

  function stepper(i, q) {
    return '<div class="ctl"><span class="stp">' +
      '<button type="button" aria-label="One less" data-a="-" data-k="' + esc(i.key) + '" data-q="' + q + '">−</button>' +
      '<span>' + q + '</span>' +
      '<button type="button" aria-label="One more" data-a="+" data-k="' + esc(i.key) + '" data-q="' + q + '">+</button></span>' +
      '<button type="button" class="del" aria-label="Remove" data-a="x" data-k="' + esc(i.key) + '">' + TRASH + '</button></div>';
  }

  function thumb(i, dark) {
    var src = null;
    if (isBreaker(i) && CFG.rowImages) src = CFG.rowImages[String(i.variant_title || "").toLowerCase()];
    if (!src && i.image) src = i.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2");
    return '<div class="th' + (dark ? " t" : "") + (src ? " im" : "") + '">' + (src ? '<img src="' + esc(src) + '" alt="" width="40" height="40" loading="lazy">' : "") + "</div>";
  }

  // A Training Kit the shopper pays for (a free one carries _awp_gift and sits in the breaker box).
  var isPaidKit = function (i) { return CFG.kitVariantId && String(i.variant_id) === String(CFG.kitVariantId) && !isGift(i); };

  // The Training Kit box: an offer with an Add button for anyone buying breakers, and the same box
  // with plus and minus once a kit is in the cart.
  function kitBox(items, bq, kq) {
    var line = items.filter(isPaidKit)[0];
    if (!line && (!bq || !CFG.kitVariantId)) return "";
    var still = CFG.kitImage ? '<img src="' + esc(CFG.kitImage) + '" alt="" width="40" height="40" loading="lazy">' : "";
    // A short muted loop of the kit in use, the width of the box, under the offer. Once the kit is in the
    // cart it has done its job, so the bought kit's box shows no video. Phones set to reduce motion get its still frame.
    var calm = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    var wide = !CFG.kitVideo || line ? "" : calm
      ? (CFG.kitPoster ? '<img class="kvid" src="' + esc(CFG.kitPoster) + '" alt="" width="288" height="144">' : "")
      : '<video class="kvid" src="' + esc(CFG.kitVideo) + '"' + (CFG.kitPoster ? ' poster="' + esc(CFG.kitPoster) + '"' : "") +
        ' muted loop playsinline autoplay disablepictureinpicture aria-hidden="true" width="288" height="144"></video>';
    var tile = '<div class="th im">' + still + "</div>";
    var words = '<span class="ud">Practice before a real emergency. 3 glass discs and a seat belt to cut.</span>';
    if (line) {
      return '<div class="up in"><div class="ur">' + tile +
        '<div class="nm"><b>Training Kit</b>' + words + '<span class="ea">' + money(line.final_price) + " each</span>" + stepper(line, line.quantity) + "</div>" +
        '<div class="rt">' + money(line.final_line_price) + "</div></div></div>";
    }
    return '<div class="up"><div class="ur">' + tile +
      '<div class="nm"><b>' + (kq ? "Add another Training Kit" : "Add a Training Kit") + "</b>" + words + "</div>" +
      '<div class="ua">' + (CFG.kitPriceCents ? "<b>" + money(CFG.kitPriceCents) + "</b>" : "") +
      '<button type="button" data-a="kit"' + (S.busy ? " disabled" : "") + ">Add</button></div></div>" + wide + "</div>";
  }

  function gearName(i) {
    var opts = (i.options_with_values || []).filter(function (o) { return o.value && o.value !== "Default Title"; })
      .map(function (o) { return o.value; });
    return i.product_title + (opts.length ? " · " + opts.join(" / ") : "");
  }

  // What the next step adds, counted from what the cart already has ("another", "2 more").
  function kitGain(have, want, lead) {
    var d = want - have;
    if (d <= 0) return "";
    if (!have) return lead + (d === 1 ? "a " + FREE + " Training Kit" : d + " " + FREE + " Training Kits");
    return lead + (d === 1 ? "another " + FREE + " Training Kit" : d + " more " + FREE + " Training Kits");
  }

  function nextLine(L, q) {
    var nowEach = L.priceAt(q), nowKits = L.kitsAt(q);
    var nxt = null;
    for (var j = 0; j < L.steps.length; j++) if (L.steps[j].min > q) { nxt = L.steps[j]; break; }
    if (!nxt && L.repeat) {
      var every = L.repeat.repeatEvery;
      var target = (Math.floor(q / every) + 1) * every;
      nxt = { min: target, each: L.priceAt(target), kits: L.kitsAt(target) };
    }
    var gets = [];
    if (nxt) {
      if (nxt.each < nowEach) gets.push(money(nxt.each) + " each");
      var kit = kitGain(nowKits, nxt.kits, gets.length ? "" : "get ");
      if (kit) gets.push(kit);
    }
    if (!gets.length) {
      var best = money(nowEach) + " each" + (nowKits ? " + " + (nowKits === 1 ? "a " + FREE + " kit" : nowKits + " " + FREE + " kits") : "");
      return '<div class="nx done">✓ Best price: ' + best + "</div>";
    }
    return '<div class="nx">Add ' + (nxt.min - q) + " more: " + gets.join(" + ") + "</div>";
  }

  function barPos(steps, q) {
    var n = steps.length, w = 100 / n;
    if (q <= 0) return 0;
    for (var j = n - 1; j >= 0; j--) {
      if (q >= steps[j].min) {
        if (j === n - 1) return 100;
        var span = steps[j + 1].min - steps[j].min;
        return w * (j + 0.5) + ((q - steps[j].min) / span) * w;
      }
    }
    return 0;
  }

  function shipLine(cart) {
    var c = CFG.country;
    if (c === "US") {
      // Protection does not count toward free shipping (Jared, Oct 23), even though checkout counts it today.
      var prot = (cart.items || []).filter(isProtection).reduce(function (n, i) { return n + i.final_line_price; }, 0);
      var left = (CFG.freeShipCents || 7500) - (cart.total_price - prot);
      var dl = CFG.deliveryUS ? '<span class="dl">' + esc(CFG.deliveryUS) + "</span>" : "";
      return left > 0
        ? '<div class="ship no">Add ' + money(left) + " for " + FREE + " US shipping" + dl + "</div>"
        : '<div class="ship">✓ ' + FREE + ' US shipping unlocked' + dl + "</div>";
    }
    if (CFG.flatShip && CFG.flatShip[c]) {
      return '<div class="ship no">' + (S.flatRate ? "Shipping: " + money(S.flatRate) + " flat" : "Flat rate shipping") +
        ", duties included</div>";
    }
    return "";
  }

  function protectionRow(items) {
    var P = PROT(), st = null;
    var line = items.filter(isProtection)[0];
    if (P && P.getState) { try { st = P.getState(); } catch (e) { st = null; } }
    // Without the protection script, a protection line still gets a row so it can be taken out.
    if (!st && line) st = { eligible: true, title: "Package protection", subtitle: "", price: line.final_line_price };
    if (!st || !st.eligible) return "";
    var on = S.ppWant != null ? S.ppWant : Boolean(line);
    // The line's price in cents when it is in the cart; otherwise the protection script's own price,
    // which it gives as formatted money ("$2.98").
    var price = line ? money(line.final_line_price)
      : typeof st.price === "number" ? money(st.price) : curSym(String(st.price || ""));
    // Two rows, Yes and No (protection contract v2). Radios, so it reads as one choice.
    var dis = S.busy ? " disabled" : "";
    var row = function (v, sel, body) {
      return '<label class="pp' + (sel ? " on" : "") + '"><input type="radio" name="awp-pp" data-a="pp" value="' + v + '"' +
        (sel ? " checked" : "") + dis + ">" + body + "</label>";
    };
    return '<div class="ppg" role="radiogroup" aria-label="Package protection">' +
      (st.intro ? '<div class="pp-i">' + esc(st.intro) + "</div>" : "") +
      row("yes", on, '<span class="pp-t"><b>' + esc(st.title || "Package protection").replace(" + ", "<br>+ ") + "</b>" +
        (st.subtitle ? "<span>" + esc(st.subtitle) + "</span>" : "") + "</span>" +
        '<span class="pp-p">' + (price ? (on ? "" : "+ ") + esc(price) : "") + "</span>") +
      row("no", !on, '<span class="pp-t"><b>' + esc(st.noLabel || "No thanks, I'll take the risk") + "</b></span>") +
      "</div>";
  }

  function draw() {
    var cart = S.cart;
    var head = function (n) {
      return '<div class="top"><b>Your cart' + (n == null ? "" : " (" + n + ")") + '</b><button type="button" class="x" data-awpc-close aria-label="Close cart">✕</button></div>';
    };
    var err = S.error ? '<div class="err" role="alert">' + esc(S.error) + "</div>" : "";
    if (!cart) return head(null) + err + '<div class="empty">' + (S.error ? '<a href="/cart" data-a="page">Open the cart page</a>' : "Loading your cart…") + "</div>";

    var items = cart.items || [];
    var br = items.filter(isBreaker), gifts = items.filter(isGift);
    var gear = items.filter(function (i) { return !isBreaker(i) && !isGift(i) && !isProtection(i) && !isPaidKit(i); });
    var pkits = items.filter(isPaidKit);
    var pq = pkits.reduce(function (s, i) { return s + i.quantity; }, 0);
    var bq = br.reduce(function (s, i) { return s + i.quantity; }, 0);
    var gq = gear.reduce(function (s, i) { return s + i.quantity; }, 0);
    var kq = gifts.reduce(function (s, i) { return s + i.quantity; }, 0);
    if (!bq && !gq && !kq && !pq) return head(0) + err + '<div class="empty">Your cart is empty.</div>';

    var bsave = 0, gsave = 0, reg = 0;
    var box = "";
    if (bq > 0 || kq > 0) {
      var L = br.length ? ladder(cart, br[0].original_price) : null;
      // The step the cart is on shows what Shopify really charges per breaker, never a figure worked out
      // here, so the ladder and the line prices can never be a cent apart.
      if (L) {
        var real = br.reduce(function (s, i) { return s + i.final_line_price; }, 0) / bq;
        var calc = L.priceAt;
        if (Math.round(real) === real && real !== calc(bq)) {
          L.priceAt = function (q) {
            var a = calc(q), b = calc(bq);
            return a === b ? real : a;
          };
          L.steps.forEach(function (s) { if (s.each === calc(bq)) s.each = real; });
        }
      }
      var lines = br.map(function (i) {
        var r = regUnit(i) * i.quantity;
        bsave += r - i.final_line_price;
        reg += r;
        return '<div class="li">' + thumb(i) + '<div class="nm"><b>' + esc(i.variant_title || i.product_title) + "</b>" +
          '<span class="ea">' + money(i.final_price) + " each</span>" + stepper(i, i.quantity) + "</div>" +
          '<div class="rt">' + (r > i.final_line_price ? "<s>" + money(r) + "</s>" : "") + money(i.final_line_price) + "</div></div>";
      }).join("");
      gifts.forEach(function (i) {
        for (var n = 0; n < i.quantity; n++) {
          var unitReg = regUnit(i);
          var unitFinal = Math.round(i.final_line_price / i.quantity);
          bsave += unitReg - unitFinal;
          reg += unitReg;
          lines += '<div class="li gift">' + thumb(i) + '<div class="nm"><b>' +
            (unitFinal ? "Training Kit" : FREE + " Training Kit (" + money(unitReg) + ")") + "</b>" +
            '<span class="ea">' + (unitFinal ? money(unitFinal) + " each" : FREE + " with your breakers") + "</span></div>" +
            '<div class="rt">' + (unitFinal < unitReg ? "<s>" + money(unitReg) + "</s>" : "") + (unitFinal ? money(unitFinal) : FREE) + "</div></div>";
        }
      });
      var head2 = "";
      if (bq > 0 && L) {
        var steps = L.steps, cur = -1;
        steps.forEach(function (s, j) { if (bq >= s.min) cur = j; });
        var st = steps.map(function (s, j) {
          return '<span class="' + (j === cur ? "on" : "") + '"><b>' + s.label + "</b>" + money(s.each) + " <em>each</em>" +
            (s.kits ? "<i>+ " + (L.repeat && s.min === L.repeat.repeatEvery && (L.repeat.giftsPerRepeat || 1) === 1
              ? "1 " + FREE + " <u>Training Kit</u> for every " + s.min
              : kitWords(s.kits).replace(/Training Kits?$/, "<u>$&</u>")) + "</i>" : "") + "</span>";
        }).join("");
        head2 = nextLine(L, bq) +
          '<div class="bar"><i style="width:' + barPos(steps, bq).toFixed(1) + '%"></i></div>' +
          '<div class="st' + (steps.length > 4 ? " st5" : "") + '" style="grid-template-columns:repeat(' + steps.length + ',1fr)">' + st + "</div>";
      }
      box = '<div class="box"><div class="bh"><span>Window Breakers (' + bq + ")</span>" +
        (bsave > 0 ? '<span class="sv">You save ' + money(bsave) + "</span>" : "") + "</div>" + head2 + lines + "</div>";
    }

    var gearHtml = "";
    if (gq > 0) {
      gearHtml = '<div class="gear">AWP gear</div><div class="gl">' + gear.map(function (i) {
        var r = regUnit(i) * i.quantity;
        var save = r - i.final_line_price;
        gsave += save;
        reg += r;
        return '<div class="li">' + thumb(i, true) + '<div class="nm"><b>' + esc(gearName(i)) + "</b>" +
          '<span class="ea">' + money(i.final_price) + " each</span>" + stepper(i, i.quantity) + "</div>" +
          '<div class="rt">' + (save > 0 ? "<s>" + money(r) + "</s>" : "") + money(i.final_line_price) +
          (save > 0 ? "<em>You save " + money(save) + "</em>" : "") + "</div></div>";
      }).join("") + "</div>" + (bq > 0 ? '<div class="gn">Gear is not part of the breaker deal.</div>' : "");
    }

    items.filter(isProtection).forEach(function (i) { reg += i.final_line_price; });
    // Bought kits count in the regular price; a kit sale, if one ever runs, goes in with the gear savings.
    pkits.forEach(function (i) { var r = regUnit(i) * i.quantity; reg += r; gsave += r - i.final_line_price; });

    // Anything Shopify takes off that is not a breaker or gear line (an order code) goes in its own line,
    // so the receipt always adds up to the subtotal checkout shows.
    var other = reg - bsave - gsave - cart.total_price;
    var sv = "";
    var tsave = reg - cart.total_price;
    if (tsave > 0 && other >= 0) {
      var rows = [];
      if (bsave > 0) rows.push(["Breaker savings", bsave]);
      if (gsave > 0) rows.push(["Gear savings", gsave]);
      if (other > 0) rows.push(["Other savings", other]);
      sv = '<div class="rg"><span>Regular price</span><span>' + money(reg) + "</span></div>" +
        rows.map(function (r) { return '<div class="sl"><span>' + r[0] + "</span><span>-" + money(r[1]) + "</span></div>"; }).join("") +
        '<div class="tot"><span>Total savings</span><span>-' + money(tsave) + "</span></div>";
    }

    return head(bq + gq + kq + pq) + shipLine(cart) + err + box + kitBox(items, bq, kq) + gearHtml +
      '<div class="ft">' + protectionRow(items) + sv + "</div>" +
      // Subtotal and Check out stay pinned to the bottom of the drawer, so a long cart never hides the button.
      '<div class="pin"><div class="sb"><span>Subtotal</span><span>' + money(cart.total_price) + "</span></div>" +
      '<div class="tx">Shipping and tax at checkout</div>' +
      '<button type="button" class="btn" data-a="go">Check out</button></div>';
  }

  function render() {
    if (!body) return;
    root.classList.toggle("awpc-busy", S.busy > 0);
    // Rebuilding the drawer drops focus: put it back on the same control after.
    // A control that is disabled while a change runs cannot hold focus, so remember it until it is back.
    var a = document.activeElement, keep = S.refocus || null;
    S.refocus = null;
    if (a && panel.contains(a) && a.getAttribute && a.getAttribute("data-a")) {
      keep = { a: a.getAttribute("data-a"), k: a.getAttribute("data-k"), v: a.type === "radio" ? a.value : null };
    }
    var html;
    try { html = draw(); } catch (e) { broke(e); return; }
    body.innerHTML = html;
    playLoops(S.open);
    // The AWP Discounts pop-up sits just above the pinned Check out bar while this drawer is open (see awp-cart.css).
    var pin = root.querySelector(".pin");
    document.documentElement.style.setProperty("--awpc-pin", (pin ? pin.offsetHeight : 0) + "px");
    if (keep && keep.a) {
      var sel = '[data-a="' + keep.a + '"]' + (keep.k ? '[data-k="' + keep.k.replace(/"/g, '\\"') + '"]' : "") +
        (keep.v ? '[value="' + keep.v + '"]' : "");
      var el = body.querySelector(sel);
      if (el && el.disabled) S.refocus = keep;
      else if (el || (el = body.querySelector(".x"))) el.focus();
    }
  }

  function bubble(cart) {
    var n = (cart.items || []).filter(function (i) { return !isProtection(i); })
      .reduce(function (s, i) { return s + i.quantity; }, 0);
    document.querySelectorAll(".cart-link__bubble").forEach(function (b) {
      b.classList.toggle("cart-link__bubble--visible", n > 0);
    });
  }

  // Every cart response carries the order it was asked in; an older answer never paints over a newer one.
  function track(promise) {
    var n = ++S.seq;
    return promise.then(function (cart) {
      if (n < S.shown || !cart || !cart.items) return;
      S.shown = n;
      S.cart = cart;
      if (tagged && PICK.inTest && cart.item_count && (cart.attributes || {}).cart_arm !== PICK.arm) { tagged = false; tagCart(cart); }
      bubble(cart);
      return Promise.all([loadCompare(cart), cart.item_count ? loadFlatRate() : null]).then(render);
    });
  }

  function refresh() { return track(getCart()); }

  var soonTimer;
  function soon(ms) {
    clearTimeout(soonTimer);
    soonTimer = setTimeout(function () { if (S.open && !S.busy) refresh().catch(function () {}); }, ms || 200);
  }

  // The flat rate abroad, as Shopify will charge it in the shopper's currency (it rounds converted rates,
  // so $9.99 can be CA$15.00). Asked once a session for a sample address in that country.
  function loadFlatRate() {
    var c = CFG.country, addr = CFG.flatShip && CFG.flatShip[c];
    // A miss (rates not ready yet, an empty cart) is tried again on a later refresh, three tries at most.
    if (!addr || S.flatRate || (S.flatTries || 0) >= 3) return Promise.resolve();
    var key = "awp-cart-flat:" + c + ":" + (CFG.currency || "");
    try { var hit = Number(sessionStorage.getItem(key)); if (hit > 0) { S.flatRate = hit; return Promise.resolve(); } } catch (e) {}
    S.flatTries = (S.flatTries || 0) + 1;
    var q = Object.keys(addr).map(function (k) {
      return "shipping_address[" + k + "]=" + encodeURIComponent(addr[k]);
    }).join("&");
    return fetch("/cart/shipping_rates.json?" + q, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var rates = (j && j.shipping_rates) || [];
        if (rates.length !== 1 || !(parseFloat(rates[0].price) > 0)) return;
        S.flatRate = Math.round(parseFloat(rates[0].price) * 100);
        try { sessionStorage.setItem(key, String(S.flatRate)); } catch (e) {}
      })
      .catch(function () {});
  }

  // Runs one cart change with the drawer locked, and always unlocks it, even when everything fails.
  function job(work) {
    S.busy++;
    S.error = "";
    render();
    var settled = false;
    var done = function () {
      if (settled) return;
      settled = true;
      S.busy = Math.max(0, S.busy - 1);
      S.ppWant = null;
      render();
      announce();
      soon(900); // the Discounts script adds or trims free kits just after a change
    };
    return Promise.resolve().then(work)
      .catch(function (e) {
        console.warn("[awp-cart]", e);
        S.error = "Sorry, we could not change that. Please try again.";
        return refresh().catch(function () {});
      })
      .then(done, done);
  }

  function addKit() {
    try { window.clarity && window.clarity("event", "awp_cart_kit_add"); } catch (x) {}
    return job(function () {
      return post("/cart/add.js", { items: [{ id: CFG.kitVariantId, quantity: 1 }] }).then(function () { return track(getCart()); });
    });
  }

  function change(key, qty) {
    return job(function () { return track(post("/cart/change.js", { id: key, quantity: qty })); });
  }

  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, no) { setTimeout(function () { no(new Error("timeout")); }, ms); })]);
  }

  function setProtection(on) {
    var P = PROT();
    S.ppWant = on;
    if (!P || !P.set) {
      // No protection script: the row can only take an existing line out.
      var line = (S.cart.items || []).filter(isProtection)[0];
      if (on || !line) { S.ppWant = null; render(); return Promise.resolve(); }
      return change(line.key, 0);
    }
    return job(function () {
      return withTimeout(Promise.resolve(P.set(on)), 10000).then(function (cart) {
        return cart && cart.items ? track(Promise.resolve(cart)) : refresh();
      });
    });
  }

  function announce() {
    if (!live || !S.cart) return;
    // A protection line left on its own is about to be removed by the protection script.
    var real = (S.cart.items || []).some(function (i) { return !isProtection(i); });
    live.textContent = real ? "Cart updated. Subtotal " + money(S.cart.total_price) + "." : "Your cart is empty.";
  }

  /* ---------- events ---------- */

  function onClick(e) {
    try {
      if (e.target.closest("[data-awpc-close]")) { close(); return; }
      var b = e.target.closest("[data-a]");
      if (!b) return;
      var a = b.getAttribute("data-a");
      if (a === "page") return; // the plain link to the cart page
      if (S.busy) { if (a !== "pp") e.preventDefault(); return; }
      // A button, not a /checkout link: Redo's toggle script swaps any checkout link for its own button.
      if (a === "go") {
        try { window.clarity && window.clarity("event", "awp_cart_checkout"); } catch (x) {}
        goCheckout(b);
        return;
      }
      if (a === "pp") return;
      var key = b.getAttribute("data-k"), q = Number(b.getAttribute("data-q") || 0);
      if (a === "+") change(key, q + 1);
      else if (a === "-") change(key, q - 1);
      else if (a === "x") change(key, 0);
      else if (a === "kit") addKit();
    } catch (x) { broke(x); }
  }

  function onChange(e) {
    try {
      if (e.target.matches('[data-a="pp"]') && e.target.checked) setProtection(e.target.value === "yes");
    } catch (x) { broke(x); }
  }

  function onKey(e) {
    if (!S.open) return;
    if (e.key === "Escape") { close(); return; }
    if (e.key !== "Tab") return;
    // Keep the tab key inside the open drawer.
    var f = panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], at = document.activeElement;
    if (!panel.contains(at) || at === panel) { (e.shiftKey ? last : first).focus(); e.preventDefault(); }
    else if (e.shiftKey && at === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && at === last) { first.focus(); e.preventDefault(); }
  }

  var lastFocus = null;
  function open() {
    if (!root) return;
    if (S.open) { refresh().catch(function () {}); return; }
    lastFocus = document.activeElement;
    S.open = true;
    S.error = "";
    root.removeAttribute("hidden");
    document.documentElement.classList.add("awpc-lock");
    requestAnimationFrame(function () { root.classList.add("awpc-in"); });
    render();
    refresh().catch(function (e) {
      console.warn("[awp-cart]", e);
      S.error = "Sorry, we could not load your cart.";
      render();
    });
    setTimeout(function () { var x = root.querySelector(".x"); (x || panel).focus(); }, 50);
    clarityTag();
    try { window.clarity && window.clarity("event", "awp_cart_open"); } catch (x) {}
  }
  // Loops play only while the drawer is open.
  function playLoops(on) {
    if (!body) return;
    body.querySelectorAll("video").forEach(function (v) {
      v.muted = true;
      if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
    });
  }

  function close() {
    if (!root || !S.open) return;
    S.open = false;
    playLoops(false);
    root.classList.remove("awpc-in");
    document.documentElement.classList.remove("awpc-lock");
    setTimeout(function () { if (!S.open) root.setAttribute("hidden", ""); }, 250);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (x) {}
  }

  // The drawer broke: send this shopper to the cart page now and give the tab back to UpCart.
  var isBroken = false;
  function broke(e) {
    console.warn("[awp-cart] broken, back to UpCart", e);
    if (isBroken) return;
    isBroken = true;
    setUpcart(true);
    try { sessionStorage.setItem(OFF_KEY, "1"); } catch (x) {}
    try { window.clarity && window.clarity("event", "awp_cart_broken"); } catch (x) {}
    location.href = "/cart";
  }

  // The store's own cart page link, in any market folder (/cart, /en-ca/cart). Nothing else.
  function isCartLink(a) {
    if (!a || a.target === "_blank") return false;
    if (a.classList && a.classList.contains("js-drawer-open-cart")) return true;
    try {
      var u = new URL(a.href, location.href);
      return u.origin === location.origin && /^(\/[a-z]{2}(-[a-z]{2})?)?\/cart\/?$/i.test(u.pathname);
    } catch (x) { return false; }
  }

  function wireNew() {
    // Cart icons and links. Capture phase, so neither the theme drawer nor anything else sees the click.
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest("a, .js-drawer-open-cart");
      if (!isCartLink(a) || (root && root.contains(a))) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      try { open(); } catch (x) { broke(x); }
    }, true);
    // Product forms (theme ajax add), anything that asks the theme to open its cart, and cart
    // changes made by the AWP Discounts embed (free kits, codes) or the protection script.
    document.addEventListener("ajaxProduct:added", function () { try { open(); } catch (x) { broke(x); } });
    document.addEventListener("cart:open", function (e) { e.stopImmediatePropagation(); try { open(); } catch (x) { broke(x); } }, true);
    document.addEventListener("cart:build", function () { soon(); });
    document.addEventListener("awp:protection:changed", function () { if (S.open && !S.busy) soon(); else if (S.open) render(); });
    // Back from checkout in Safari or Chrome shows the old page as it was: read the cart again.
    window.addEventListener("pageshow", function (e) { if (e.persisted && S.open) refresh().catch(function () {}); });
  }

  /* ---------- tagging (both arms) ---------- */

  var clarityTries = 0;
  function clarityTag() {
    if (!PICK.inTest) return;
    try {
      if (typeof window.clarity === "function") {
        window.clarity("set", "cart_arm", PICK.arm);
        if (PICK.qa) window.clarity("set", "cart_arm_qa", "yes");
        return;
      }
    } catch (e) {}
    if (++clarityTries < 30) setTimeout(clarityTag, 500);
  }

  // The arm goes on the cart once it holds something, so checkout and the order carry it. Read from the
  // page first (Liquid), so most pages make no request at all.
  var tagged = false;
  function tagCart(cart) {
    if (!PICK.inTest || tagged || !cart || !cart.item_count) return Promise.resolve();
    var want = { cart_arm: PICK.arm };
    if (PICK.qa) want.cart_arm_qa = "yes";
    var have = cart.attributes || {};
    if (have.cart_arm === want.cart_arm && (!PICK.qa || have.cart_arm_qa === "yes")) { tagged = true; return Promise.resolve(); }
    tagged = true;
    return post("/cart/update.js", { attributes: want }).then(function () { return checkTag(want, 0); })
      .catch(function () { tagged = false; });
  }

  // Another script's attribute post at the same moment can wipe ours, so look again and post again,
  // only our own keys, at most three more times.
  var TAG_WAITS = [600, 1500, 3000];
  function checkTag(want, n) {
    return new Promise(function (r) { setTimeout(r, TAG_WAITS[n]); }).then(getCart).then(function (c) {
      var a = c.attributes || {};
      if (a.cart_arm === want.cart_arm && (!want.cart_arm_qa || a.cart_arm_qa === "yes")) return;
      if (n >= TAG_WAITS.length - 1) { tagged = false; return; }
      return post("/cart/update.js", { attributes: want }).then(function () { return checkTag(want, n + 1); });
    });
  }

  function wireTag() {
    tagCart({ item_count: CFG.cartCount || 0, attributes: { cart_arm: CFG.cartArm, cart_arm_qa: CFG.cartArmQa } });
    // A first add on this page (any add path that uses fetch) tags the cart right after.
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function () {
      var args = arguments;
      return nativeFetch.apply(null, args).then(function (res) {
        var url = String((args[0] && args[0].url) || args[0] || "");
        if (/\/cart\/add/.test(url)) {
          if (!tagged && PICK.inTest) setTimeout(function () { getCart().then(tagCart).catch(function () {}); }, 300);
        }
        // Any other script's attribute post can wipe cart_arm, so look again after every cart change.
        if (PICK.inTest && /\/cart\/(add|change|update)/.test(url)) {
          setTimeout(function () {
            getCart().then(function (c) {
              if (c.item_count && (c.attributes || {}).cart_arm !== PICK.arm) { tagged = false; tagCart(c); }
            }).catch(function () {});
          }, 900);
        }
        if (/\/cart\/add/.test(url)) {
          if (PICK.arm === "new" && S.open && !S.busy) soon(400);
        }
        return res;
      });
    };
    document.addEventListener("ajaxProduct:added", function () {
      if (!tagged && PICK.inTest) getCart().then(tagCart).catch(function () {});
    });
    clarityTag();
  }

  /* ---------- start ---------- */

  var off = false;
  try { off = sessionStorage.getItem(OFF_KEY) === "1"; } catch (e) {}
  try {
    if (PICK.arm === "new" && !off) {
      // Before theme.js runs (this file is deferred ahead of it), so the theme never builds its own drawer.
      if (window.theme && theme.settings) theme.settings.cartType = "awp";
      setUpcart(false);
      build();
      wireNew();
      window.AWPCart = { open: open, close: close, refresh: refresh };
    } else {
      setUpcart(true);
    }
  } catch (e) {
    setUpcart(true);
    if (window.theme && theme.settings && theme.settings.cartType === "awp") theme.settings.cartType = "drawer";
    console.warn("[awp-cart] off, UpCart stays on", e);
  }
  try { wireTag(); } catch (e) {}

  // UpCart prints line properties that start with "_" (like the free kit's _awp_gift) for shoppers to see.
  // Turn on UpCart's own "hide" setting, and hide any that still show inside UpCart's shadow root.
  try {
    if (window.upcartSettings) window.upcartSettings.hideSingleUnderscoredProperties = true;
    var hideTries = 0;
    var hideHidden = function () {
      var R = window.upcartDocumentOrShadowRoot;
      if (!R || !R.querySelectorAll) { if (++hideTries < 80) setTimeout(hideHidden, 250); return; }
      var sweep = function () {
        R.querySelectorAll(".upcart-item-property").forEach(function (p) {
          var k = p.querySelector("strong");
          if (k && /^\s*_/.test(k.textContent) && p.style.display !== "none") p.style.display = "none";
        });
      };
      sweep();
      new MutationObserver(sweep).observe(R, { childList: true, subtree: true });
    };
    hideHidden();
  } catch (e) {}

  // ?open_cart=1 opens whichever cart this shopper has (checkout's Edit cart link), then leaves the address clean.
  try {
    var qs = new URLSearchParams(location.search);
    if (qs.get("open_cart") === "1") {
      qs.delete("open_cart");
      history.replaceState(null, "", location.pathname + (qs.toString() ? "?" + qs : "") + location.hash);
      var tries = 0;
      var openWhenReady = function () {
        if (window.AWPCart) return window.AWPCart.open();
        if (typeof window.upcartOpenCart === "function") return window.upcartOpenCart();
        if (++tries < 40) setTimeout(openWhenReady, 250);
      };
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", openWhenReady);
      else openWhenReady();
    }
  } catch (e) {}
})();
